"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UserGroup = {
    name: 'UserGroup',
    suppressMirroring: true,
    tooltipKey: 'UserGroup.icon.label',
    render: function (props, svgRef) {
        return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: ['UserGroup', props.className].join(' '), width: "14", height: "14", x: "0", y: "0", version: "1.1", viewBox: "0 0 14 14", xmlSpace: "preserve", ref: svgRef }, props),
            props.tooltip && react_1.default.createElement("title", null, props.tooltip),
            react_1.default.createElement("path", { className: "svgToolTipPane", fill: "none", d: "M0 0h14v14H0z" }),
            react_1.default.createElement("path", { className: "iconColor", d: "M1 3c0-1.105.672-2 1.5-2S4 1.895 4 3s-.672 2-1.5 2S1 4.104 1 3zm3.006 6.107A.96.96 0 014 9c0-.517.127-1.005.379-1.451.158-.282.367-.519.598-.733a1.96 1.96 0 00-.223-.777 1.997 1.997 0 00-.668-.719C3.622 5.773 3.094 6 2.5 6c-.599 0-1.125-.227-1.578-.68-.281.183-.505.422-.672.719S0 6.656 0 7l.491 4.554A.5.5 0 00.988 12h3.095a.48.48 0 00.228-.063l-.305-2.83zM11.5 4c.828 0 1.5-.896 1.5-2 0-1.105-.672-2-1.5-2S10 .895 10 2c0 1.104.672 2 1.5 2zm2.254 1.039a1.997 1.997 0 00-.668-.719c-.464.453-.992.68-1.586.68-.593 0-1.114-.224-1.564-.668.039.215.064.437.064.668 0 .554-.119 1.068-.328 1.509.4.269.722.621.957 1.047.246.445.371.93.371 1.444l-.182 2h2.265a.5.5 0 00.498-.454L14 6c0-.344-.082-.664-.246-.961zm-4 3c.164.297.246.617.246.961l-.419 4.546a.5.5 0 01-.498.454H5.988a.5.5 0 01-.497-.446L5 9c0-.344.083-.664.25-.961s.391-.536.672-.719c.453.453.979.68 1.578.68.594 0 1.122-.227 1.586-.68.281.183.504.422.668.719zM7.5 3C6.672 3 6 3.895 6 5s.672 2 1.5 2S9 6.104 9 5s-.672-2-1.5-2z" })));
    },
};
exports.default = UserGroup;
